import React from 'react';
import { PDFDownloadLink, Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import damasLogo from "src/assets/images/logo.png";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    padding:20
    // backgroundColor: '#E4E4E4'
  },
  section: {
    marginLeft: 30,
    padding: 10,
    flexGrow: 1
  },
  image: {
    width: 120,
    float:"left"
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding:10
  },
  dateText: {
    fontSize: 10
  },
});

const TableComponent = ({ data }) => {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
  return (
    <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.dateText}>Report generated on {currentDate}</Text>
        </View>
        
        <View style={styles.section}>
          <Image
                style={styles.image}
                src={damasLogo}  
          />
          <Text>Plastic Seal Report (Total: {data.length})</Text>
          <View style={{ flexDirection: 'row', marginTop: 10 }}>
            <Text style={{ width: 150,fontSize: 15 }}>Serial</Text>
            <Text style={{ width: 150,fontSize: 15 }}>Status</Text>
            <Text style={{ width: 250,fontSize: 15 }}>Created Date</Text>
          </View>
          {data.map(item => (
            <View key={item.id} style={{ flexDirection: 'row', marginTop: 2 }}>
              <Text style={{ width: 150,fontSize: 12  }}>{item.serialNo}</Text>
              <Text style={{ width: 150, fontSize: 12  }}>{item.status}</Text>
              <Text style={{ width: 250, fontSize: 12  }}>{item.createdAt}</Text>
            </View>
          ))}
        </View>
    </Page>
    
  );
};

export default TableComponent;